<template>
  <div class="page">
    <Header
      :setting="{
        title: '超音波影像',
        hasCancelMethod: true,
      }"
      @cancel="$emit('cancel')"
      class="mb4"
    />
    <div
      v-if="album.photos.length !== 0"
      class="row--central mb4"
    >
      <div class="label label--secondary ph4">
        照片
      </div>
    </div>
    <div class="row--auto-fill-1">
      <div
        v-for="photo in album.photos"
        :key="photo"
        @click="$emit('chooseImage',{
          type: 'photo',
          url: photo
        })"
        class="bc--secondary border-radius-1 mh2 mb4"
      >
        <img
          :src="photo"
          alt=""
          class="border-radius-1"
        >
      </div>
    </div>
    <div
      v-if="album.videos.length !== 0"
      class="row--central mb4"
    >
      <div class="label label--secondary ph4">
        影片
      </div>
    </div>
    <div class="row--auto-fill-1">
      <div
        v-for="video in album.videos"
        :key="video"
        @click="$emit('chooseImage',{
          type: 'video',
          url: video
        })"
        class="bc--secondary border-radius-1 mh2 mb4"
      >
        <video
          autoplay
          loop
          muted
          playsinline
          class="border-radius-1"
        >
          <source
            :src="video"
            type="video/mp4"
          >
          Your browser does not support this video file.
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    album: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: ['chooseImage', 'cancel'],
};
</script>
